module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAACCAYAAABCOhwFAAAAOElEQVQYV2OUiL3wn4mRkYGZgZGBiZGJgQXEBtNImImJgRXMZ2ZgRWaDxJhQ1UL0QswCmclIawsA+GAFvcedZN8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/title_desc.png
// module id = wU4L
// module chunks = 1